// extracted by mini-css-extract-plugin
export default {"order-row":"OrderDeliveryTable_order-row__dWgSa"};